import { render, staticRenderFns } from "./bill-tag.vue?vue&type=template&id=a3e774c8&"
import script from "./bill-tag.vue?vue&type=script&lang=js&"
export * from "./bill-tag.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports